import Navbar from "@/components/feature/Navbar";

import { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";

import Footer from "../../../components/feature/Footer";

import {
  BaseUrl,
  Unichat_Url,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
} from "../../../Services/Urls";
import {
  makeApiRequest,
  callApi,
  makeApiRequest_seperateDb,
  makeApiRequest_seperateDb_get,
} from "../../../Services/ApiService";
import { TailSpin } from "react-loader-spinner";

import {
  getRecords,
  PostRecords,
  uploadMultipleFiles,
  uploadFile,
} from "../../../Services/ApiCall";

import {
  decryptOtp,
  getUser,
  formatDisplayDate,getEmbedUrl
} from "../../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../../Context/Context";

interface ContentItem {
  id: string;
  title: string;
  date: string;
  description: string;
  summary: string;
  image?: string;
  pdfUrl?: string;
  category: string;
  author?: string;
  readTime?: string;
}



const NewsResearchDetailPage = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState(null);

  useEffect(() => {
    getcontent();
    window.scrollTo(0, 0);
  }, []);

  const getcontent = () => {
    //   let userdata = getUser();

    let url = `${Unichat_Url}/universaldairy/research/${id}`;

    makeApiRequest_seperateDb(
      url,
      (response: any) => {
        if (response?.success === true && response?.record != null) {
          setContent(response?.record || null);
        }
      },
      (error: any) => {},
    );
  };



  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Image */}
      <div className="relative w-full h-80 md:h-[450px] overflow-hidden">
        <img
          src={
            content?.Images ||
            "https://readdy.ai/api/search-image?query=Modern%20pharmaceutical%20manufacturing%20facility%20with%20clean%20rooms%20and%20advanced%20equipment%20in%20a%20biotech%20company%20setting%20with%20workers%20in%20protective%20gear&width=1200&height=600&seq=news1detail&orientation=landscape"
          }
          alt="Universal Dairy Expands Manufacturing Facility in Haryana"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
          <div className="max-w-4xl mx-auto">
            <span className="inline-block px-4 py-1.5 bg-primary text-white text-xs font-medium rounded-full mb-4 whitespace-nowrap">
              {content?.Category}
            </span>
            <h1 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-4">
              {content?.Title}
            </h1>
            <div className="flex flex-wrap items-center gap-4 text-white/80 text-sm">
              <span className="flex items-center">
                <i className="ri-calendar-line mr-1.5"></i>
                {formatDisplayDate(content?.Date)}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <nav className="flex items-center text-sm text-gray-500">
              <Link to="/" className="hover:text-primary transition-colors">
                Home
              </Link>
              <i className="ri-arrow-right-s-line mx-2"></i>
              <Link
                to="/news-research"
                className="hover:text-primary transition-colors"
              >
                News & Research
              </Link>
              <i className="ri-arrow-right-s-line mx-2"></i>
              <span className="text-gray-700 truncate max-w-[200px]">
                {content?.Category}
              </span>
            </nav>
            {content?.Docs && (
              <button
                onClick={() => {
                  if (!content?.Docs) return;

                  const link = document.createElement("a");
                  link.href = content.Docs;
                  link.download = "document.pdf"; // optional custom filename
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
                className="flex items-center text-primary hover:underline cursor-pointer whitespace-nowrap text-sm font-medium"
              >
                <i className="ri-file-pdf-line mr-1.5"></i>
                Download Pdf
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Content */}
      <article className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Summary */}
          <div className="bg-primary/5 border-l-4 border-primary p-6 rounded-r-lg mb-10">
            <p className="text-gray-700 font-medium leading-relaxed text-lg">
              {content?.Summary}
            </p>
          </div>

          {/* Main Content */}

          {content?.Url && content?.Url != "" && (
            <div className="prose prose-lg max-w-none">
              <div>
                <iframe
                  width="100%"
                  height="315"
                  src={getEmbedUrl(content?.Url)}
                  title="YouTube video player"
                  frameBorder="1"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
              <p className="text-small text-gray-500 mt-10 mb-4 flex items-center">
                {content?.Description}
              </p>
            </div>
          )}
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default NewsResearchDetailPage;
